/**
 * Route for `publisher-api`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { PublisherApiPage } from "../features/publisher-api/PublisherApiPage";

export const publisherApiRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/publisher-api",
	component: PublisherApiPage,
});

export default publisherApiRoute;
